import { observable } from 'mobx'

import { z } from '@authy/lib-common/utils/zod'
import { client, RouterInput } from '@authy/lib-client/trpc'

import { appState } from '@/appState'

type SortType = NonNullable<RouterInput['identities']['listIdentities']['sort']>

export const SearchSchema = z.object({
    sort: z
        .string()
        .transform((val) => val as Extract<keyof SortType, string>)
        .optional()
        .default('lastSeenAt'),
    sortBy: z.enum(['asc', 'desc']).optional().default('desc'),
    searchTerm: z.string().optional(),
})

export type Search = z.infer<typeof SearchSchema>

export const pageSize = 50

export const listIdentities = async (search: Search, offset: number, abortController?: AbortController) => {
    const result = await client.identities.listIdentities.query(
        {
            tenantId: appState.tenant!._id.toString(),
            searchTerm: search.searchTerm,
            sort: {
                [search.sort]: search.sortBy,
            },
            offset,
            limit: pageSize,
            returnCount: offset === 0,
        },
        { signal: abortController?.signal }
    )

    return observable(result)
}
